import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { BrandLogo } from "@evolua/ui";
import "../../auth/auth.css";

export function AuthLayout({
  title,
  lead,
  children,
}: {
  title: string;
  lead?: string;
  children: ReactNode;
}) {
  return (
    <div className="evolua-auth">
      <aside className="evolua-auth__brand-panel">
        <h2>Pessoas com dado confiável.</h2>
        <p>
          Portal corporativo de RH com procedência visível, MFA obrigatório e trilha de
          auditoria.
        </p>
        <ul className="evolua-auth__signals">
          <li>MFA obrigatório em todos os perfis</li>
          <li>Dados com selo de atualização do ERP</li>
          <li>Acesso alinhado à LGPD</li>
        </ul>
      </aside>
      <div className="evolua-auth__form-col">
        <div className="evolua-auth__panel">
          <Link to="/" className="evolua-auth__brand">
            <BrandLogo size="auth" />
          </Link>
          <h1 className="evolua-auth__title">{title}</h1>
          {lead ? <p className="evolua-auth__lead">{lead}</p> : null}
          {children}
        </div>
      </div>
    </div>
  );
}
